export function getTableCurrentPage(offset: number, limit: number): number {
    return Math.ceil((offset - 1) / limit + 1);
}

export function pageAfterDeleteChanged(total: number, limit: number): boolean {
    return (total - 1) % limit === 0;
}
